"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmCalendarFooter = void 0;
const classnames_1 = __importDefault(require("classnames"));
const date_fns_1 = require("date-fns");
const react_1 = __importDefault(require("react"));
const SmCalendarFooter = (_a) => {
    var { holidays, className, children } = _a, props = __rest(_a, ["holidays", "className", "children"]);
    const calendarFooterClassnames = (0, classnames_1.default)('c-calendar__footer', className);
    return (react_1.default.createElement("div", Object.assign({}, props, { className: calendarFooterClassnames }), holidays === null || holidays === void 0 ? void 0 :
        holidays.map((holiday) => (react_1.default.createElement("span", { key: `ff-${(0, date_fns_1.format)(holiday.date, 'dd')}` }, `${(0, date_fns_1.format)(holiday.date, 'dd')} - ${holiday.name}`))),
        children));
};
exports.SmCalendarFooter = SmCalendarFooter;
//# sourceMappingURL=SmCalendarFooter.js.map